
const bodySpacing = () => {

  const body = document.body;
  const header = document.querySelector('header');

  document.addEventListener("DOMContentLoaded", () => {
    if(header) {
      body.style.paddingTop = header.offsetHeight + 'px';
    }
  });

  window.addEventListener('resize', () => {
    if(header) {
      body.style.paddingTop = header.offsetHeight + 'px';
    }
  });
}

export default bodySpacing;
